import { combineReducers } from 'redux';
import user from './user';
import order from './order';
import balance from './balance';
import ohlc from './ohlc';
import history from './history';
import ledger from './ledger';
import referral from './referral';
import fees from './fees';
import coins from './coins';
import glassbooks from './glassbooks';
import status from './status';
import assets from './assets';
import addressbook from './addressbook';
import automation from './automation';
import eurtrade from './eurtrade';
import market from './market';

export default combineReducers({
  user,
  order,
  balance,
  ohlc,
  history,
  ledger,
  referral,
  fees,
  coins,
  glassbooks,
  status,
  assets,
  addressbook,
  automation,
  eurtrade,
  market,
});
